import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "columns" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "column" }, [
    /*#__PURE__*/_createElementVNode("h1", { class: "title is-narrow is-spaced" }, "Past Payments")
  ])
], -1)
const _hoisted_3 = ["href", "download"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_o_icon = _resolveComponent("o-icon")!
  const _component_o_loading = _resolveComponent("o-loading")!
  const _component_o_table_column = _resolveComponent("o-table-column")!
  const _component_o_button = _resolveComponent("o-button")!
  const _component_o_table = _resolveComponent("o-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_o_loading, {
      active: _ctx.isPageLoading,
      "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isPageLoading) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_o_icon, {
          pack: "fa",
          icon: "spinner",
          size: "large",
          spin: "",
          variant: "primary"
        })
      ]),
      _: 1
    }, 8, ["active"]),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_o_table, { data: _ctx.pastPayments }, {
        default: _withCtx(() => [
          _createVNode(_component_o_table_column, {
            field: "PaymentDate",
            label: "Payment Date",
            width: "40",
            numeric: "",
            sortable: ""
          }, {
            default: _withCtx((props) => [
              _createTextVNode(_toDisplayString((props.row.PaymentDate)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_o_table_column, {
            field: "TicketNumber",
            label: "Case/Citation Number",
            width: "40",
            sortable: "",
            customSort: _ctx.caseOrCitationSort
          }, {
            default: _withCtx((props) => [
              _createTextVNode(_toDisplayString(_ctx.getCaseOrCitation(props.row)), 1)
            ]),
            _: 1
          }, 8, ["customSort"]),
          _createVNode(_component_o_table_column, {
            field: "BillingLastName",
            label: "Last Name",
            width: "40",
            numeric: ""
          }, {
            default: _withCtx((props) => [
              _createTextVNode(_toDisplayString(props.row.BillingLastName), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_o_table_column, {
            field: "BillingFirstName",
            label: "First Name",
            width: "40",
            numeric: ""
          }, {
            default: _withCtx((props) => [
              _createTextVNode(_toDisplayString(props.row.BillingFirstName), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_o_table_column, {
            field: "PaymentType",
            label: "Payment Type",
            width: "40",
            numeric: ""
          }, {
            default: _withCtx((props) => [
              _createTextVNode(_toDisplayString(props.row.PaymentType), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_o_table_column, {
            field: "PartialFeeFinePaymentAmount",
            label: "Paid Amount",
            width: "40",
            numeric: ""
          }, {
            default: _withCtx((props) => [
              _createTextVNode(_toDisplayString((props.row.PartialFeeFinePaymentAmount + props.row.PartialContemptPaymentAmount + props.row.PartialProbationPaymentAmount).toLocaleString('en-US', { style: 'currency', currency: 'USD',})), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_o_table_column, {
            field: "ConvenienceFee",
            label: "Convenience Fee",
            width: "40",
            numeric: ""
          }, {
            default: _withCtx((props) => [
              _createTextVNode(_toDisplayString(props.row.ConvenienceFee == null ? "$0.00" : props.row.ConvenienceFee.toLocaleString('en-US', { style: 'currency', currency: 'USD',})), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_o_table_column, {
            field: "button",
            label: "",
            width: "40"
          }, {
            default: _withCtx((props) => [
              (!_ctx.isMobile())
                ? (_openBlock(), _createBlock(_component_o_button, {
                    key: 0,
                    variant: "info",
                    onClick: ($event: any) => (_ctx.printReceiptReport(props.row.ID))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Print")
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    href: '/api/Report/DownloadReceiptReport?ID=' + props.row.ID,
                    download: props.row.PaymentDate,
                    class: "button is-info"
                  }, "Print", 8, _hoisted_3))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])
    ])
  ], 64))
}